<template>
	<page-template>
		<template #content>
			<v-container fluid>
				<v-row class="d-flex align-center justify-space-between flex-wrap pt-16 px-4" no-gutters>
					<v-col cols="auto">
						<v-btn text outlined @click="goBack">
							<v-icon left>icon-angle-left</v-icon>
							{{ $t("stocks") }}
						</v-btn>
					</v-col>
				</v-row>
			</v-container>

			<v-container fluid>
				<v-row class="px-4 mb-2" v-if="stock && batches.length">
					<v-col cols="12">
						<v-card class="ant-card px-4 py-2" outlined>
							<v-card-title class="headline pb-2">
								{{ getProductName(stock.productId?.name) }}
							</v-card-title>
							<v-divider class="mb-4" />
							<v-card-text>
								<v-row>
									<v-col cols="12" sm="3" class="py-2">
										<div>
											<strong>{{ $t("quantity") }}:</strong>
											{{ batches[0].quantity }}
										</div>
									</v-col>
									<v-col cols="12" sm="3" class="py-2" v-if="batches[0].measurement_no">
										<div>
											<strong>{{ $t("batch_no") }}:</strong>
											{{ batches[0].measurement_no }}
										</div>
									</v-col>
									<v-col cols="12" sm="3" class="py-2" v-if="batches[0].weight">
										<div>
											<strong>{{ $t("weight_kg") }}:</strong>
											{{ batches[0].weight }}
										</div>
									</v-col>
									<v-col cols="12" sm="3" class="py-2" v-if="batches[0].notes">
										<div>
											<strong>{{ $t("notes") }}:</strong>
											{{ batches[0].notes }}
										</div>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>

				<v-row class="px-4" dense>
					<v-col v-for="batch in batches" :key="batch._id" cols="12" md="6">
						<v-card class="mb-6 ant-card" outlined>
							<v-row no-gutters>
								<v-col
									cols="5"
									class="d-flex align-center justify-center"
									style="background: #f9f9f9; position: relative"
								>
									<template v-if="batch.imagesLoaded?.length">
										<v-img
											:src="batch.imagesLoaded[0]"
											height="250px"
											width="100%"
											class="pointer"
											@click.stop="openGallery(batch.imagesLoaded, 0)"
											contain
										/>
										<div v-if="batch.imagesLoaded.length > 1" class="image-badge">
											+{{ batch.imagesLoaded.length - 1 }}
										</div>
									</template>
									<template v-else>
										<div
											style="
												height: 250px;
												width: 100%;
												display: flex;
												align-items: center;
												justify-content: center;
												background-color: #eee;
											"
										>
											<span>{{ $t("no_image") }}</span>
										</div>
									</template>
								</v-col>
								<v-col cols="7" class="pa-4">
									<v-card-title class="headline mb-2"> {{ $t("batch") }}: {{ batch.quantity }} </v-card-title>
									<v-divider class="mb-2" />
									<v-card-text>
										<div v-if="batch.measurements?.length">
											<strong>{{ $t("measurements") }}:</strong>
											<div v-for="(m, midx) in batch.measurements" :key="midx" class="mb-1">
												<div v-if="m.length !== undefined">{{ $t("length") }}: {{ m.length }}</div>
												<div v-if="m.width !== undefined">{{ $t("width") }}: {{ m.width }}</div>
												<div v-if="m.height !== undefined">{{ $t("height") }}: {{ m.height }}</div>
												<div>{{ $t("pieces") }}: {{ m.pieces }}</div>
											</div>
										</div>
									</v-card-text>
								</v-col>
							</v-row>

							<v-card-actions>
								<v-btn text color="primary" @click.stop="addToBasket(batch)">
									{{ $t("add_to_basket") }}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>

				<v-row v-if="!batches.length">
					<v-col cols="12" class="text-center">
						<p>{{ $t("no_stock_batches_found") }}</p>
					</v-col>
				</v-row>
			</v-container>

			<div
				v-if="showGallery"
				class="fullscreen-overlay d-flex flex-column justify-center align-center"
				@click="closeGallery"
			>
				<v-btn icon @click.stop="closeGallery" class="gallery-close-btn">
					<v-icon color="white">icon-cross</v-icon>
				</v-btn>
				<v-btn icon @click.stop="prevImage" class="gallery-arrow-left">
					<v-icon color="white">icon-angle-left</v-icon>
				</v-btn>
				<v-btn icon @click.stop="nextImage" class="gallery-arrow-right">
					<v-icon color="white">icon-angle-right</v-icon>
				</v-btn>
				<v-img
					:src="currentGallery[currentIndex]"
					:key="currentGallery[currentIndex]"
					max-width="90%"
					max-height="90%"
					contain
					@click.stop
				/>
			</div>
		</template>
	</page-template>
</template>

<script>
import remote from "../../../data/remote";
import PageTemplate from "../../templates/PageTemplate.vue";
import { mapState, mapMutations } from "vuex";

export default {
	name: "PublicBatches",
	components: { PageTemplate },
	data() {
		return {
			company: null,
			stock: null,
			batches: [],
			loading: false,
			showGallery: false,
			currentGallery: [],
			currentIndex: 0,
		};
	},
	computed: {
		...mapState("basket", ["items"]),
	},
	methods: {
		...mapMutations("basket", { ADD_ITEM: "ADD_ITEM" }),

		fetchSellerInfo() {
			const publicUrl = this.$route.params.publicUrl;
			remote.companies.getPublicCompany(publicUrl, {
				onSuccess: (res) => (this.company = res.company),
				onFail: (err) => console.error("couldn't load seller info", err),
			});
		},

		async fetchStockDetails() {
			this.loading = true;
			remote.companies.getPublicStock(this.$route.params.stockId, {
				onSuccess: async (result) => {
					this.stock = result.stock;
					this.batches = result.batches;
					await this.loadBatchImages();
					this.loading = false;
				},
				onFail: () => (this.loading = false),
			});
		},

		async loadBatchImages() {
			for (const batch of this.batches) {
				this.$set(batch, "imagesLoaded", []);
				if (Array.isArray(batch.images)) {
					for (const key of batch.images) {
						try {
							const blob = await this.loadImageBlob(key);
							batch.imagesLoaded.push(URL.createObjectURL(blob));
						} catch {}
					}
				}
			}
		},

		loadImageBlob(imgKey) {
			return new Promise((res, rej) => {
				remote.files.get(imgKey, {
					onSuccess: (r) => res(new Blob([r], { type: "image/jpeg" })),
					onFail: rej,
				});
			});
		},

		openGallery(images, idx) {
			this.currentGallery = images;
			this.currentIndex = idx;
			this.showGallery = true;
			window.addEventListener("keydown", this.handleKeydown);
		},

		closeGallery() {
			this.showGallery = false;
			window.removeEventListener("keydown", this.handleKeydown);
		},

		prevImage() {
			this.currentIndex = (this.currentIndex - 1 + this.currentGallery.length) % this.currentGallery.length;
		},

		nextImage() {
			this.currentIndex = (this.currentIndex + 1) % this.currentGallery.length;
		},

		handleKeydown(e) {
			if (e.key === "ArrowLeft") this.prevImage();
			if (e.key === "ArrowRight") this.nextImage();
			if (e.key === "Escape") this.closeGallery();
		},

		goBack() {
			this.$router.push({
				name: "publicStocks",
				params: { publicUrl: this.$route.params.publicUrl },
			});
		},

		getProductName(nameObj) {
			if (!nameObj) return this.$t("unnamed_stock");
			const lang = (this.$i18n && this.$i18n.locale) || "en";
			return nameObj[lang] || nameObj._default || this.$t("unnamed_stock");
		},

		addToBasket(batch) {
			const seller = {
				referenceId: batch.companyId,
				name: this.company.name,
				countryId: this.company.countryId,
				isAbstract: false,
			};

			// pull the full Map of localized names
			const nameMap = this.stock.productId.name;
			// your unit code lives on stock.unit
			const unitCode = this.stock.unit;
			// productId for the basket
			const productId = this.stock.productId._id;
			// price if present
			const amount = batch.price || 0;

			const item = {
				_id: batch._id,
				stockId: batch.stockId,
				productId,
				name: nameMap,
				unitCode,
				quantity: batch.quantity,
				amount,
				measurement_no: batch.measurement_no,
				measurements: batch.measurements,
				weight: batch.weight,
				notes: batch.notes,
				imagesLoaded: batch.imagesLoaded,
				seller,
			};

			this.ADD_ITEM(item);
		},
	},

	created() {
		this.fetchSellerInfo();
		this.fetchStockDetails();
	},
};
</script>

<style scoped>
.pointer {
	cursor: pointer;
}
.fullscreen-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.8);
	z-index: 9999;
	cursor: pointer;
}
.gallery-close-btn {
	position: absolute;
	top: 5%;
	right: 5%;
}
.gallery-arrow-left {
	position: absolute;
	top: 50%;
	left: 5%;
	transform: translateY(-50%);
}
.gallery-arrow-right {
	position: absolute;
	top: 50%;
	right: 5%;
	transform: translateY(-50%);
}
.image-badge {
	position: absolute;
	bottom: 8px;
	right: 8px;
	background: rgba(0, 0, 0, 0.6);
	color: white;
	border-radius: 12px;
	padding: 2px 6px;
}
</style>
